import {APP_ID, Component, ElementRef, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Object} from 'aws-sdk/clients/s3';
import {isPlatformBrowser} from '@angular/common';
import {NavigationEnd, Router, RouterEvent} from "@angular/router";
import {filter} from "rxjs/operators";
import {UserService} from "../shared/services/user/user.service";
import {ToastrService} from "ngx-toastr";

declare var $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
    collapedSideBar: boolean;
    token: any;
    person: any;
    isSwitchUser: any;
    constructor(private elementRef: ElementRef,
                public router: Router,
                private userService: UserService,
                private toastr: ToastrService,
                @Inject(PLATFORM_ID) private platformId: Object,
                @Inject(APP_ID) private appId: string) {
        this.router.events.pipe(filter((event: RouterEvent) => event instanceof NavigationEnd)).subscribe((data: any) => {
            this.token  = localStorage.getItem('token');
            this.person = JSON.parse(localStorage.getItem('person'));
            this.isSwitchUser = localStorage.getItem('isSwitchUser');
        });
    }

    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
    }

    receiveCollapsed($event) {
        this.collapedSideBar = $event;
    }

    onActivate(event: any) {
        if (isPlatformBrowser(this.platformId)) {
            let scrollToTop = window.setInterval(() => {
                let pos = window.pageYOffset;
                if (pos > 0) {
                    window.scrollTo(0, 0);
                } else {
                    window.clearInterval(scrollToTop);
                }
            }, 16);
        }
    }
}
